import { AutogenModelEdiOrderIc, AutogenRowEdiOrderIc } from "./autogen/AutogenModelEdiOrderIc";

export class ModelEdiOrderIc extends AutogenModelEdiOrderIc<RowEdiOrderIc> {
	constructor() {
		super(RowEdiOrderIc);
	}
}

export class RowEdiOrderIc extends AutogenRowEdiOrderIc {
}